const tags: string[] = [
	'javascript',
	'python',
	'typescript',
	'c',
	'c++',
	'java',
	'c#',
	'perl',
	'ruby',
	'rails',
	'golang',
	'scala',
	'sql',
	'mongo-db',
	'jest',
	'AWS',
	'GCP',
	'Digital-Ocean',
	'Netlify',
	'Heroku',
	'spring-boot',
	'express.js',
	'Node.js',
];

export default tags;
